import {
    GET_MERCHANT_TERMINALS_TRANSACTION_LOADING, GET_MERCHANT_TERMINALS_TRANSACTION_FAILED, GET_MERCHANT_TERMINALS_TRANSACTION_SUCCESS, REMOVE_MERCHANT_TERMINALS_TRANSACTION

} from "../types";

const initialState = {
    TerminalsChartData: null,
    loading: null,
    error: null,
};

export const getTerminalsTransactionChartReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_TERMINALS_TRANSACTION_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_TERMINALS_TRANSACTION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                TerminalsChartData: action.payload,
            };
        case GET_MERCHANT_TERMINALS_TRANSACTION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_TERMINALS_TRANSACTION:
            return initialState;

        default:
            return state;
    }
};
